import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/online-payments/transactions', request)
}

export {get}
